import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingWrapper = _resolveComponent("LoadingWrapper")!
  const _component_AccountManager = _resolveComponent("AccountManager")!
  const _component_CrmRegionWrapper = _resolveComponent("CrmRegionWrapper")!
  const _component_ClientServicesPerson = _resolveComponent("ClientServicesPerson")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_LoadingWrapper, {
      classes: [
			'CampaignEditorRow',
			'CampaignEditorSubtitle'
		],
      isLoading: _ctx.isLoading,
      tag: "h2"
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode(" Campaign Management ", -1 /* CACHED */)
      ]))]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["isLoading"]),
    _createVNode(_component_AccountManager),
    _createVNode(_component_CrmRegionWrapper),
    _createVNode(_component_ClientServicesPerson)
  ], 64 /* STABLE_FRAGMENT */))
}